import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiQueryHook } from '../../../../common/queryClient/createApiQueryHook';
import { AlgorithmUrl } from '../../query/AlgorithmUrl';
import { AlgorithmFilterClauseFormDataType } from '../schema/types';
import { AlgorithmFilterClauseFormDataSchema } from '../schema/AlgorithmFilterClauseFormDataSchema';

interface AlgorithmFilterClauseQueryParams {
  id: number;
}

const getAlgorithmFilterClause = (params?: AlgorithmFilterClauseQueryParams) =>
  apiClient
    .get<AlgorithmFilterClauseFormDataType>(
      expand(AlgorithmUrl.FILTER_CLAUSE, params)
    )
    .then((response) =>
      AlgorithmFilterClauseFormDataSchema.parse(response.data)
    );

export const useGetAlgorithmFilterClauseQuery = createApiQueryHook(
  ['algorithm-filter-clause'],
  getAlgorithmFilterClause
);
